import { LoggingContext } from '../logging/logging.types';
import * as sentry from '../logging/sentry';
import { getBiErrorLogger } from '../statistics/bi-error-logger/bi-error-logger';
import { BiErrorDescription } from '../statistics/bi-error-logger/bi-error-logger.types';

import {
  ErrorParams,
  LoggerExtraParams,
  LogParams,
} from './error-logger.types';

export const errorLogger = {
  setLoggingContext({ userId, artifactVersion }: LoggingContext) {
    sentry.setUserContext({ userId });
    sentry.setArtifactVersion(artifactVersion);
  },

  logError(errorParams: ErrorParams) {
    console.error(errorParams);
    const { biErrorDescription, errorDescription, biParams = {} } = errorParams;
    const biErrorLogger = getBiErrorLogger();

    if (!biErrorDescription) {
      biErrorLogger
        .logError({ id: 1999, name: 'unhandled-error' })
        .catch((reason) => {
          console.error('could not send bi', reason);
        });
    } else {
      const { p1, p2, p3, p4 } = biParams;
      biErrorLogger
        .logError(biErrorDescription, p1, p2, p3, p4)
        .catch((reason) => {
          console.error('could not send bi', reason);
        });
    }

    const error = errorDescription || biErrorDescription || 'Unknown Error';
    sentry.logError(error, errorParams.otherParams);
  },

  logInfo(logParams: LogParams) {
    sentry.logInfo(logParams.description, logParams.otherParams);
  },

  createLoggingCatcher(
    biError: BiErrorDescription,
    otherParams?: LoggerExtraParams,
  ) {
    return (reason) => {
      errorLogger.logError({
        biErrorDescription: biError,
        errorDescription: reason,
        otherParams,
      });
      return Promise.reject(reason);
    };
  },
};

export const installUnhandled = () => {
  const original = window.onunhandledrejection;
  window.onunhandledrejection = (...args) => {
    if (original) {
      try {
        original(...args);
      } catch (ex) {
        console.error(ex);
      }
    }

    const event: PromiseRejectionEvent = args[0];
    errorLogger.logError({
      errorDescription: 'Unhandled rejection',
      otherParams: {
        reason: event && event.reason ? event.reason : 'reason unknown',
      },
    });
  };

  return () => {
    window.onunhandledrejection = original;
  };
};
